import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentComponentBuyNow: {
        id: 'integration.quoteandbind.directives.custom-quote.BOP.BuyNow',
        defaultMessage: 'BuyNow'
    },
    paymentSource: {
        id: 'amp.bc3.directives.templates.payment-instrument-bc3.Source',
        defaultMessage: 'Source'
    },
    bankAccountSource: {
        id: 'amp.bc3.directives.templates.payment-instrument-bc3.Bank Account',
        defaultMessage: 'Bank Account'
    },
    cardIssuer: {
        id: 'platform.paymentdetails.credit-card-auto-details.Card Issuer',
        defaultMessage: 'Card Issuer',
    },
    selectIssuer: {
        id: 'platform.paymentdetails.credit-card-auto-details.-- Please Select --',
        defaultMessage: '-- Please Select --'
    },
    paymentMethod: {
        id: 'quoteandbind.views.payment-details.Payment Method',
        defaultMessage: 'Payment Method',
    },
    bankAccount: {
        id: 'quoteandbind.views.payment-details.Bank Account',
        defaultMessage: 'Bank Account',
    },
    creditCard: {
        id: 'quoteandbind.views.payment-details.Credit Card',
        defaultMessage: 'Credit Card',
    },
    monthly: {
        id: 'billing.billing-summary.Monthly Autopay',
        defaultMessage: 'Monthly Autopay'
    },
    semiAnnual: {
        id: 'billing.billing-summary.Semi Annual',
        defaultMessage: 'Semi Annual'
    },
    annual: {
        id: 'billing.billing-summary.Annual',
        defaultMessage: 'Annual'
    },
    accountType: {
        id: 'quoteandbind.directives.templates.bank-account-details-quote.Account Type',
        defaultMessage: 'Account Type',
    },
    accountNumber: {
        id: 'quoteandbind.directives.templates.bank-account-details-quote.Account Number',
        defaultMessage: 'Account Number',
    },
    routingNumber: {
        id: 'quoteandbind.directives.templates.bank-account-details-quote.Routing (ABA) Number',
        defaultMessage: 'Routing (ABA) Number',
    },
    bankName: {
        id: 'quoteandbind.directives.templates.bank-account-details-quote.Bank Name',
        defaultMessage: 'Bank Name',
    },
    cancel: {
        id: 'platform.paymentdetails.Cancel',
        defaultMessage: 'Cancel',
    },
    tncLabel: {
        id: 'tdic.payment.component.By checking this box, I agree to the Terms of Use including the Billing and Payments section and have kept a copy of this authorization for my records.',
        defaultMessage: 'By checking this box, I agree to the {link} including the Billing and Payments section and have kept a copy of this authorization for my records.'
    },
    tncLabelAutopay: {
        id: 'tdic.payment.component.By checking this box, I agree to the Terms of Use including the Billing and Payments section and have kept a copy of this authorization for my records.Autopay',
        defaultMessage: 'By checking this box, I agree to the {link} including the Billing and Payments section and have kept a copy of this authorization for my records.{br}I understand and agree that monthly invoices will be sent as electronic-only documents.'
    },
    printAuthorization: {
        id: 'tdic.portal.payment.Print Authorization',
        defaultMessage: 'Print Authorization'
    }
});
